<template>
	<div class="board ls-flex-col-center w-100">
		<!-- 面包屑 -->
		<div class="w-100 BreadcrumbVue">
			<BreadcrumbVue :index="2" :type="title" :detailType="titleDetail"></BreadcrumbVue>
		</div>
		<div class="board_coutent ls-flex p-tb-40 ov-hidden">
			<div class="w-100 ls-flex">
				<div v-if="!phoneDetail" class="ls-flex-col menu m-r-15">
					<div class="menu_title  ls-flex ls-flex-center ls-jc-center bg-c-3546A0 m-b-10">
						<span class="f-bold f-fff p-lr-20 ta-center">{{$cetihuan.kzcpzx[$store.state.lang]}}</span>
					</div>
					<div class="">
						<div @click="select(item,{},1)" class="menu_item cursor-pointer" v-for="(item,index) in dataList" :key="item.id">
							<div :class="id == item.id ? 'bg-c-3546A0' : 'bg-c-ECECEC m-b-10'" class="menu_item_title ls-flex ls-al-center ls-jc-center">
								<span :class="id == item.id ? 'f-fff' : 'f-333'" class="ta-center text-ellipsis-1">{{item.name}}</span>
								<img v-show="id != item.id" class="menu_img_jia" src="../../assets/image/productCenter_jia.png" style="width: 15px;height: 15px;" alt="">
								<img v-show="id == item.id" class="menu_img_jian" src="../../assets/image/productCenter_jian.png" style="width: 15px;height: 2px;" alt="">
								<!-- <img src="../../assets/image/productCenter_more.png" style="width: 11px;height: 20px;" alt=""> -->
							</div>
							<div :style="{display:id == item.id ? 'block' :'none'}" class="menu_im">
								<div @click.stop="select(item,im,2)" class="m-b-10 bg-c-ECECEC" v-for="(im,ix) in item.ejlist" :key="im.id">
									<div class="menu_item_title ls-flex ls-al-center ls-jc-center">
										<span :class="itemId == im.id ? 'f-3546A0' : 'f-666'" class="ta-center text-ellipsis-1">{{im.name}}</span>
										<img class="menu_item_title_img" src="../../assets/image/productCenter_more.png" style="" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="kefu bg-c-3546A0">
						<!-- <img src="../../assets/fw.png" style="width: 100%;height: 240px;" alt=""> -->
						<div class="kefu_img" :style="{backgroundImage:`url(${kefuImg})`}"></div>
						<div class=" ls-flex-col ls-al-center ls-jc-center p-tb-20">
							<div class="ls-flex ls-al-center">
								<img src="../../assets/fw_phone.png" style="" alt="">
								<span class="f-fff m-l-10">{{$cetihuan.fwrx[$store.state.lang]}}</span>
							</div>
							<div class="f-fff fwtel">{{indexData.fwtel || ''}}</div>
						</div>
					</div>
				</div>
				<div class="ls-flex-flex ls-flex-col">
					<!-- <router-view></router-view> -->
					<div class="list ls-flex-col" v-if="!detail">
						<div class="board_title m-b-25">
							<div class="f-000 w-max-content">
								{{title || ''}}
								<div class="board_title_line w-100 m-t-15"></div>
							</div>
							<div class="board_line"></div>
						</div>
						<div class="w-100">
							<div class="" v-show="itemShow || itemId == item.id" v-for="(item,index) in list" :key="item.id">
								<div class="p-10 right_item m-b-25" v-for="(im,ix) in item.list" :key="item.id">
									<!-- <img class="right_item_img" :src="im.image" style="" alt=""> -->
									<div class="right_item_img" :style="{backgroundImage:`url(${im.image})`}"></div>
									<div class="ls-flex-flex p-10 ls-flex-col">
										<span class="fs-18">{{item.name || ''}}</span>
										<div class="line w-100 m-tb-10"></div>
										<p class="l-h-30 fs-16 f-666 text-ellipsis-3" :class="$store.state.lang == 'en' ? 'ta-justify' : ''">
											{{im.con || ''}}
										</p>
										<div class="ls-flex-flex"></div>
										<div class="ljxq ls-flex m-t-10">
											<div @click="toDetail(im.id,im)" class="detail pc">{{$cetihuan.ljxq[$store.state.lang]}}</div>
											<div @click="toDetailPhone(im.id,im)" class="detail phone">{{$cetihuan.ljxq[$store.state.lang]}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="w-100" v-else>
						<div class="w-100 detail_content">
							<div class="ls-flex-col">
								<div class="p-20 ls-flex bg-c-fff detail_top">
									<div class="detail_top_img" :style="{backgroundImage:`url(${ejlist.image})`}"></div>
									<!-- <img :src="ejlist.image" style="width: 362px;height: 244px;" alt=""> -->
									<div class="ls-flex-flex m-l-20 ls-flex-col">
										<span class="m-b-20 fs-18 f-333 f-bold">{{ejlist.title || ''}}</span>
										<div class="ls-flex-flex ov-hidden">
											<p class="fs-16 f-666 l-h-30" :class="$store.state.lang == 'en' ? 'ta-justify' : ''">
												{{ejlist.con || ''}}
											</p>
										</div>
										<div class="parting-line-f5f5f5 m-tb-20"></div>
										<div class="ls-flex ls-jc-space-between">
											<div class="ls-flex ls-al-center">
												<img src="../../assets/image/rexian.png" style="width: 37px;height: 33px;" alt="">
												<div class="m-l-15">
													<div class="fs-16 f-333">{{$cetihuan.qgrx[$store.state.lang]}}</div>
													<div class="fs-16 f-333">{{indexData.fwtel || ''}}</div>
												</div>
											</div>
											<div class="bg-c-3546A0 p-tb-20 p-l-40 p-r-40 fs-18 f-fff">{{$cetihuan.zxzx[$store.state.lang]}}</div>
										</div>
									</div>
								</div>
								<div class="m-tb-20 bg-c-fff p-20">
									<div class="title w-max-content">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-22 f-333">产品简介  /  <span class="f-999 fs-22">INTRODUCTION</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="p-t-20" v-html="cpInfo.content"></div>
								</div>
								<div v-if="cpInfo.images" class="m-b-20 bg-c-fff p-20">
									<div class="title w-max-content">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-22 f-333">产品展示  /  <span class="f-999 fs-22">PRODUCT  DISPLAY</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="w-100 p-t-20 cpImage">
										<img :src="cpInfo.images[cpIndex]" style="width: 100%;height: 100%;" alt="">
									</div>
									<div class="ls-flex">
										<div class="ls-flex ls-al-center ls-jc-center p-r-10">
											<div @click="cpSelect(2)" class="ls-flex ls-al-center ls-jc-center cp_zuo cursor-pointer">
												<div class="cp_zuo_img"></div>
											</div>
										</div>
										<div class="ls-flex-flex ov-hidden">
											<div class="cp_box p-t-20">
												<div :style="{marginLeft: cpIndex > 2 && cpIndex > (cpInfo.images.length - 3) ? -230 * (cpInfo.images.length - 3) - 20 + 'px' :  -230 * cpIndex + 'px'}" class="ls-flex ls-jc-space-between w-max-content">
													<div @click="cpSelectIndex(index)" :class="cpIndex == index ? 'select' : 'noSelect'" class="cp_item cursor-pointer" v-for="(item,index) in cpInfo.images" :key="index">
														<!-- <img :src="item" style="width: 226px; height: 155px;" alt=""> -->
														<div :style="{backgroundImage: `url(${item})`}" class="cp_item_img"></div>
													</div>
												</div>
											</div>
										</div>
										<div class="ls-flex ls-al-center ls-jc-center p-l-10">
											<div @click="cpSelect(1)" class="ls-flex ls-al-center ls-jc-center cp_you cursor-pointer">
												<div class="cp_yuo_img"></div>
											</div>
										</div>
									</div>
									
								</div>
								<div class="m-b-20 bg-c-fff p-20">
									<div class="title w-max-content">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-22 f-333">生产区展示  /  <span class="f-999 fs-22">WORKSHOP  SHOW</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="ls-flex ls-flex-rw ls-jc-space-between p-t-20">
										<div class="scq_item" v-for="(item,index) in cpInfo.scqimages" :key="index">
											<img :src="item" style="width: 100%; height: 100%;" alt="">
										</div>
										<div v-if="cpInfo.scqimages ? cpInfo.scqimages.length % 3 == 2 : false" class="scq_item"></div>
									</div>
								</div>
								<div class="bg-c-fff p-20">
									<div class="title w-max-content m-b-25">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-22 f-333">联系我们  /  <span class="f-999 fs-22">CONTACT  US</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="ls-flex bg-c-f8f8f8 lianxiwomen p-tb-20">
										<div class="ls-flex-col p-lr-20 lianxiwomen_zuo">
											<div class="ls-flex-flex ls-flex ls-al-center m-b-15">
												<img src="../../assets/image/dizhi.png" style="width: 26px;height: 33px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{indexData.company || ''}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.address || ''}}
													</div>
												</div>
											</div>
											<div class="ls-flex-flex ls-flex ls-al-center m-b-15">
												<img src="../../assets/image/dianhua.png" style="width: 28px;height: 28px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{$cetihuan.telephone[$store.state.lang]}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.fwtel || ''}}
													</div>
												</div>
											</div>
											<div class="ls-flex-flex ls-flex ls-al-center m-b-15">
												<img src="../../assets/image/emli.png" style="width: 28px;height: 22px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{$cetihuan.mailbox[$store.state.lang]}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.email || ''}}
													</div>
												</div>
											</div>
											<div class="ls-flex-flex ls-flex ls-al-center ">
												<img src="../../assets/image/emli.png" style="width: 30px;height: 30px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{$cetihuan.wangzhi[$store.state.lang]}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.url || ''}}
													</div>
												</div>
											</div>
										</div>
										<div class="ls-flex-flex">
											<baidu-map class="h-100 w-100" id="map" style="display: flex; flex-direction: column" :scroll-wheel-zoom="true" :dragging="true" :center="'中国'">
											  <bm-view style="width: 100%; height: 100px; flex: 1"></bm-view>
											  <bm-marker :position="center"></bm-marker>
											  <!-- marker属性 -->
											  <!-- animation="BMAP_ANIMATION_BOUNCE" -->
											</baidu-map>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="detail_content_phone">
							<div class="ls-flex-col">
								<div class="p-20 ls-flex-col bg-c-fff detail_top">
									<div class="ls-flex m-b-10">
										<div class="detail_top_img" :style="{backgroundImage:`url(${ejlist.image})`}"></div>
										<!-- <img :src="ejlist.image" style="width: 200px;height: 100px;" alt=""> -->
										<div class="ls-flex-col ls-jc-center ls-flex-flex m-l-15">
											<span class="fs-18 f-333 m-b-10 text-ellipsis-2">{{ejlist.title || ''}}</span>
											<div class="ls-flex ls-al-center m-b-10">
												<img src="../../assets/image/rexian.png" style="width: 24px;height: auto;" alt="">
												<div class="m-l-15">
													<div class="fs-14 f-333">{{$cetihuan.qgrx[$store.state.lang]}}</div>
													<div class="fs-14 f-333">{{indexData.fwtel || ''}}</div>
												</div>
											</div>
											<div class="bg-c-3546A0 p-tb-10 fs-18 f-fff ta-center">{{$cetihuan.zxzx[$store.state.lang]}}</div>
										</div>
									</div>
									<div class="ls-flex-flex ls-flex-col">
										<div class="ls-flex-flex ov-hidden">
											<p class="fs-16 f-666 l-h-30">
												{{ejlist.con || ''}}
											</p>
										</div>
									</div>
								</div>
								<div class="m-tb-20 bg-c-fff p-20">
									<div class="title w-max-content">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-16 f-333">产品简介  /  <span class="f-999 fs-16">INTRODUCTION</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="p-t-20" v-html="cpInfo.content"></div>
								</div>
								<div v-if="cpInfo.images" class="m-b-20 bg-c-fff p-20">
									<div class="title w-max-content">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-16 f-333">产品展示  /  <span class="f-999 fs-16">PRODUCT  DISPLAY</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="w-100 p-t-20 cpImage">
										<img :src="cpInfo.images[cpIndex]" style="width: 100%;height: 100%;" alt="">
									</div>
									<div class="ls-flex">
										<div class="ls-flex ls-al-center ls-jc-center p-r-10">
											<div @click="cpSelect(2)" class="ls-flex ls-al-center ls-jc-center cp_zuo cursor-pointer">
												<div class="cp_zuo_img"></div>
											</div>
										</div>
										<div class="ls-flex-flex ov-hidden">
											<div class="cp_box p-tb-20">
												<div :style="{marginLeft: cpIndex > 2 && cpIndex > (cpInfo.images.length - 2) ? -115 * (cpInfo.images.length - 2) + 20 + 'px' : -115 * cpIndex + 'px'}" class="ls-flex ls-jc-space-between w-max-content">
													<div @click="cpSelectIndex(index)" :class="cpIndex == index ? 'select' : 'noSelect'" class="cp_item cursor-pointer" v-for="(item,index) in cpInfo.images" :key="index">
														<!-- <img :src="item" style="width: 113px; height: 75px;" alt=""> -->
														<div :style="{backgroundImage: `url(${item})`}" class="cp_item_img"></div>
													</div>
												</div>
											</div>
										</div>
										<div class="ls-flex ls-al-center ls-jc-center p-l-10">
											<div @click="cpSelect(1)" class="ls-flex ls-al-center ls-jc-center cp_you cursor-pointer">
												<div class="cp_yuo_img"></div>
											</div>
										</div>
									</div>
									
								</div>
								<div class="m-b-20 bg-c-fff p-20">
									<div class="title w-max-content">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-16 f-333">生产区展示  /  <span class="f-999 fs-16">WORKSHOP  SHOW</span></span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="ls-flex ls-flex-rw ls-jc-space-between p-t-20">
										<div class="scq_item" v-for="(item,index) in cpInfo.scqimages" :key="index">
											<img :src="item" style="width: 100%; height: 100%;" alt="">
										</div>
										<div v-if="cpInfo.scqimages ? cpInfo.scqimages.length % 3 == 2 : false" class="scq_item"></div>
									</div>
								</div>
								<div class="bg-c-fff p-20">
									<div class="title w-max-content m-b-25">
										<div class="ls-flex title_text">
											<div class="leb_1 bg-c-3546A0 m-r-10"></div>
											<span class="fs-16 f-333">联系我们  /  <span class="f-999 fs-16">CONTACT  US</span>  </span>
										</div>
										<div class="leb_2"></div>
									</div>
									<div class="ls-flex-col bg-c-f8f8f8 lianxiwomen p-tb-20">
										<div class="w-100 lianxiwomen_map">
											<baidu-map class="h-100 w-100" id="map" style="display: flex; flex-direction: column" :scroll-wheel-zoom="true" :dragging="true" :center="'中国'">
											  <bm-view style="width: 100%; height: 100px; flex: 1"></bm-view>
											  <bm-marker :position="center"></bm-marker>
											  <!-- marker属性 -->
											  <!-- animation="BMAP_ANIMATION_BOUNCE" -->
											</baidu-map>
										</div>
										<div class="ls-flex-col p-lr-20 lianxiwomen_zuo">
											<div class="ls-flex-flex ls-flex ls-al-center m-b-15">
												<img src="../../assets/image/dizhi.png" style="width: 26px;height: 33px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{indexData.company || ''}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.address || ''}}
													</div>
												</div>
											</div>
											<div class="ls-flex-flex ls-flex ls-al-center m-b-15">
												<img src="../../assets/image/dianhua.png" style="width: 28px;height: 28px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{$cetihuan.telephone[$store.state.lang]}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.fwtel || ''}}
													</div>
												</div>
											</div>
											<div class="ls-flex-flex ls-flex ls-al-center m-b-15">
												<img src="../../assets/image/emli.png" style="width: 28px;height: 22px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{$cetihuan.mailbox[$store.state.lang]}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.email || ''}}
													</div>
												</div>
											</div>
											<div class="ls-flex-flex ls-flex ls-al-center ">
												<img src="../../assets/image/emli.png" style="width: 30px;height: 30px;" alt="">
												<div class="m-l-10">
													<div class="fs-18 f-333 m-b-10">
														{{$cetihuan.wangzhi[$store.state.lang]}}
													</div>
													<div class="fs-14 f-666">
														{{indexData.url || ''}}
													</div>
												</div>
											</div>
										</div>
										
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getCpListData, getCpCpInfoData, getIndexData } from "@/api/api.js";
import BreadcrumbVue from "../../components/Breadcrumb.vue";
export default {
	data() {
		return {
			id:'',
			title:'',
			titleDetail:'',
			itemId:'',
			dataList:[],
			list:[],
			detail:false,
			phoneDetail:false,
			ejlist:{},
			cpInfo:{
				images:[],
				scqimages:[]
			},
			indexData:{},
			center: {
				lng: 112.58898,
				lat: 37.811073,
			},
			mId:'',
			itemShow:true,
			cpIndex:0,
			kefuImg: require('@/assets/fw.png')
		};
	},
	components: {
		BreadcrumbVue
	},
	methods: {
		getDate(){
			let _self = this;
			_self.detail = false;
			getCpListData().then((res) => {
				_self.dataList = res.data;
				if (_self.$route.query.id) {
					_self.id = _self.$route.query.id
					_self.dataList.forEach(item=>{
						if (item.id == _self.id) {
							_self.list = item.ejlist;
						}
					})
				}else{
					_self.id = _self.dataList[0].id;
					_self.list = _self.dataList[0].ejlist;
				}
				_self.title = _self.dataList[0].name;
			});
			getIndexData().then((res) => {
				_self.indexData = res.data;
				if (_self.indexData.lat) {
					_self.center.lat = _self.indexData.lat;
					_self.center.lng = _self.indexData.lng;
				}
			});
		},
		select(item,im,type){
			let _self = this;
			_self.ejlist = {};
			_self.id = item.id;
			_self.mId = '';
			_self.detail = false;
			if (type == 1) {
				_self.itemShow = true;
				_self.itemId = '';
				_self.list = item.ejlist;
				_self.id = item.id;
				_self.title = item.name;
				_self.titleDetail = '';
			} else{
				_self.itemShow = false;
				_self.itemId = im.id;
				_self.titleDetail = im.name;
			}
		},
		toDetail(id,im){
			let _self = this;
			_self.ejlist = im;
			_self.detail = true;
			_self.cpInfo = {};
			_self.mId = id;
			_self.cpIndex = 0;
			getCpCpInfoData(id).then((res) => {
				_self.cpInfo = res.data;
				if (_self.cpInfo.images) {
					_self.cpInfo.images = _self.cpInfo.images.split(',');
				}
				if (_self.cpInfo.scqimages) {
					_self.cpInfo.scqimages = _self.cpInfo.scqimages.split(',');
				}
				if (_self.$store.state.lang == 'en') {
					_self.cpInfo.content = _self.formatRichText2(_self.cpInfo.content);
				} else{
					_self.cpInfo.content = _self.formatRichText(_self.cpInfo.content);
				}
			});
			// let { href } = _self.$router.resolve(`/ProductCenter/detail?id=${_self.id}&mId=${id}&itemId=${_self.itemId}`);
			// window.open(href, '_blank');
		},
		toDetailPhone(id,im){
			let _self = this;
			_self.phoneDetail = true;
			_self.ejlist = im;
			_self.detail = true;
			_self.cpInfo = {};
			_self.mId = id;
			_self.cpIndex = 0;
			getCpCpInfoData(id).then((res) => {
				_self.cpInfo = res.data;
				if (_self.cpInfo.images) {
					_self.cpInfo.images = _self.cpInfo.images.split(',');
				}
				if (_self.cpInfo.scqimages) {
					_self.cpInfo.scqimages = _self.cpInfo.scqimages.split(',');
				}
				if (_self.$store.state.lang == 'en') {
					_self.cpInfo.content = _self.formatRichText2(_self.cpInfo.content);
				} else{
					_self.cpInfo.content = _self.formatRichText(_self.cpInfo.content);
				}
			});
			// let { href } = _self.$router.resolve(`/ProductCenter/detail?id=${_self.id}&mId=${id}&itemId=${_self.itemId}`);
			// window.open(href, '_blank');
		},
		cpSelect(num){
			let _self = this;
			let index = _self.cpInfo.images.length;
			if (num == 1) {
				if (_self.cpIndex == _self.cpInfo.images.length - 1) {
					_self.cpIndex = 0
				} else{
					_self.cpIndex ++
				}
			} else{
				if (_self.cpIndex == 0) {
					_self.cpIndex = _self.cpInfo.images.length - 1
				} else{
					_self.cpIndex --
				}
			}
			console.log(_self.cpIndex);
		},
		cpSelectIndex(ix){
			let _self = this;
			_self.cpIndex = ix;
		},
		// v-html 图片宽100%
		formatRichText(html) { //控制小程序中图片大小
			let newContent = ''
			if (typeof(html) == 'string') { //检测值为字符串才能进行replace操作
				
				newContent = html.replace(/<p[^>]*>/gi,'<div class="pp"><span class="lingxing"></span><p class="ls-flex-flex" style="padding: 0px; margin-top: 0px;margin-bottom: 0px;font-size: 14px;color: rgb(51, 51, 51);white-space: normal;background-color: rgb(255, 255, 255);line-height: 3em;text-indent: 0em;">');
				newContent = newContent.replace(/<\/p>/gi,'</div></p>');
				return newContent;
			}
		},
		formatRichText2(html) { //控制小程序中图片大小
			let newContent = ''
			if (typeof(html) == 'string') { //检测值为字符串才能进行replace操作
				
				newContent = html.replace(/<p[^>]*>/gi,'<div class="pp ta-justify"><span class="lingxing"></span><p class="ls-flex-flex" style="padding: 0px; margin-top: 0px;margin-bottom: 0px;font-size: 14px;color: rgb(51, 51, 51);white-space: normal;background-color: rgb(255, 255, 255);line-height: 3em;text-indent: 0em;">');
				newContent = newContent.replace(/<\/p>/gi,'</div></p>');
				return newContent;
			}
		}
	},
	created() {
		this.getDate();
	},
	mounted() {
		// this.init();
	},
	watch: {
		'$store.state.lang':{
			handler: function (val, oldVal) {
				//刷新页面
				this.getDate();
			},
			deep: true,
		},
		$route: {
			handler: function (val, oldVal) {
				this.getDate();
			},
			deep: true,
		},
	},
	beforeDestroy() {
		
	}
};
</script>

<style lang="scss">
	.BreadcrumbVue{
		@media screen and (max-width: 768px) {
			display: none !important;
		}
	}
	.board {
		width: 100%;
		height: auto;
		background-image: url('../../assets/bg.png');
		background-repeat: no-repeat;
		background-size: 50%;
		background-position: -10% top;
		@media screen and (max-width: 768px) {
			background-size: 100%;
		}
		.board_coutent{
			width: 1200px;
			@media screen and (max-width: 768px) {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
		.menu{
			width: 343px;
			@media screen and (max-width: 768px) {
				width: 150px;
			}
		}
		.menu_title{
			width: 343px;
			height: 108px;
			span{
				font-size: 32px;
			}
			@media screen and (max-width: 768px) {
				width: 150px;
				height: 50px;
				span{
					font-size: 16px;
				}
			}
		}
		.menu_item{
			width: 343px;
			@media screen and (max-width: 768px) {
				width: 150px;
			}
		}
		.menu_item_title{
			width: 343px;
			height: 80px;
			position: relative;
			@media screen and (max-width: 768px) {
				width: 150px;
				height: 50px;
				font-size: 16px;
				.menu_item_title_img{
					width: 5px !important;
					height: 10px !important;
					position: absolute;
					right: 10px !important;
					top: 50%;
					transform: translateY(-50%);
				}
				.menu_img_jia{
					width: 7px !important;
					height: 7px !important;
					position: absolute;
					right: 10px !important;
					top: 50%;
					transform: translateY(-50%);
				}
				.menu_img_jian{
					width: 7px !important;
					height: 1px !important;
					position: absolute;
					right: 10px !important;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			span{
				font-size: 24px;
				padding: 0 40px 0 20px;
				margin-right: 20px;
				@media screen and (max-width: 768px) {
					font-size: 16px;
					padding: 0 20px 0 5px;
					margin-right: 5px;
				}
			}
			.menu_img_jia{
				width: 15px;
				height: 15px;
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}
			.menu_img_jian{
				width: 15px;
				height: 2px;
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}
			.menu_item_title_img{
				width: 11px;
				height: 20px;
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.menu_im{
			transition: all 0.5s 0s;
		}
		.kefu_img{
			width: 100%;
			height: 240px;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			@media screen and (max-width: 768px) {
				height: 120px;
			}
		}
		.kefu{
			img{
				width: 29px;
				height: 29px;
				@media screen and (max-width: 768px) {
					width: 20px;
					height: 20px;
				}
			}
			span{
				font-size: 18px;
				@media screen and (max-width: 768px) {
					font-size: 14px;
				}
			}
			.fwtel{
				font-size: 22px;
				@media screen and (max-width: 768px) {
					font-size: 14px;
				}
			}
		}
		.list{
			width: 100%;
			@media screen and (max-width: 768px) {
				width: 96%;
			}
		}
		.board_title{
			position: relative;
			div{
				font-size: 1.875rem;
				@media screen and (max-width: 768px) {
					font-size: 1rem;
				}
			}
			.board_title_line{
				position: relative;
				z-index: 99;
				width: max-content;
				border-bottom: 2px solid #3546A0;
			}
			.board_line{
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				height: 2px;
				background-color: #ECECEC;
			}
		}
		.right_item{
			border: 1px solid #ECECEC;
			display: flex;
			@media screen and (max-width: 768px) {
				flex-direction: column;
			}
			.line{
				border-spacing: 5px;
				border-bottom: 1px dashed #ECECEC;
			}
			.ljxq{
				justify-content: flex-end;
				@media screen and (max-width: 768px) {
					flex-direction: column;
					.pc{
						display: none !important;
					}
					.phone{
						display: block !important;
					}
				}
				.phone{
					display: none;
				}
				.pc{
					display: block;
				}
			}
			.detail{
				padding: 0.9375rem 1.875rem;
				color: #333;
				border: 1px solid #ECECEC;
				@media screen and (max-width: 768px) {
					border: 1px solid #3546A0;
					background-color: #3546A0;
					color: #fff;
					text-align: center;
				}
			}
			.right_item_img{
				width: 300px;
				height: 200px;
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				margin-right: 1.25rem;
				@media screen and (max-width: 768px) {
					width: 100%;
					height: 120px;
					margin-right: 0rem;
				}
			}
			span{
				color: #333;
			}
		}
		.right_item:hover{
			border: 1px solid #3546A0;
		}
		.right_item:hover .detail{
			border: 1px solid #3546A0;
			background-color: #3546A0;
			color: #fff;
		}
		.right_item:hover span{
			color: #3546A0 !important;
			font-weight: bold;
		}
		.detail_content{
			@media screen and (max-width: 768px) {
				display: none !important;
			}
			.detail_top{
				border: 1px solid #ECECEC;
				.detail_top_img{
					width: 362px;
					height: 244px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					// @media screen and (max-width: 768px) {
					// 	width: 100%;
					// 	height: 200px;
					// }
				}
			}
			.title{
				position: relative;
				.title_text{
					position: relative;
					z-index: 99;
				}
				.leb_1{
					width: 36px;
					height: 26px;
					transform: skewX(165deg);
				}
				.leb_2{
					height: 21px;
					background: #E1E1E1;
					position: absolute;
					width: 105%;
					top: 14px;
					transform: skewX(165deg);
				}
			}
			.cpImage{
				height: 500px;
			}
			.cp_zuo{
				width: 11px;
				height: 73px;
				background: #ECECEC;
				border-radius: 2px;
				.cp_zuo_img{
					width: 100%;
					height: 30px;
					background-repeat: no-repeat;
					background-size: 250%;
					background-position: center;
					background-image: url('../../assets/image/cp_zuo_1.png');
				}
			}
			.cp_zuo:hover {
				background: #3546A0;
			}
			.cp_zuo:hover .cp_zuo_img{
				background-image: url('../../assets/image/cp_zuo_2.png');
			}
			.cp_you{
				width: 11px;
				height: 73px;
				background: #ECECEC;
				border-radius: 2px;
				.cp_yuo_img{
					width: 100%;
					height: 30px;
					background-repeat: no-repeat;
					background-size: 250%;
					background-position: center;
					background-image: url('../../assets/image/cp_yuo_2.png');
				}
			}
			.cp_you:hover {
				background: #3546A0;
			}
			.cp_you:hover .cp_yuo_img{
				background-image: url('../../assets/image/cp_yuo_1.png');
			}
			.cp_box{
				min-width: 100%;
				width: 0;
				overflow: hidden;
				.cp_item{
					margin-right: 1%;
					.cp_item_img{
						width: 226px;
						height: 155px;
						background-repeat: no-repeat;
						background-size: cover;
						background-position: center;
					}
				}
			}
			.noSelect{
				border: 1px solid transparent;
			}
			.select{
				border: 1px solid #3546A0;
			}
			.scq_item{
				width: 32%;
				margin-bottom: 12px;
			}
			.lianxiwomen{
				// height: 316px;
				.lianxiwomen_zuo{
					width: 40%;
				}
			}
			#map{
				.BMap_cpyCtrl, .anchorBL {
					display: none !important;
				}
			}
			.pp{
				display: flex;
			}
			.lingxing{
				display: inline-block;
				margin-top: 16px;
				width: 10px;
				height: 10px;
				background-color: #3546A0;
				transform: skewX(157deg);
				margin-right: 10px;
			}
		}
		.detail_content_phone{
			display: none;
			@media screen and (max-width: 768px) {
				display: block !important;
			}
			.detail_top{
				border: 1px solid #ECECEC;
				.detail_top_img{
					width: 200px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					// @media screen and (max-width: 768px) {
					// 	width: 100%;
					// 	height: 200px;
					// }
				}
			}
			.title{
				position: relative;
				.title_text{
					position: relative;
					z-index: 99;
				}
				.leb_1{
					width: 15px;
					height: 15px;
					transform: skewX(165deg);
					margin-top: 2px;
				}
				.leb_2{
					height: 12px;
					background: #E1E1E1;
					position: absolute;
					width: 105%;
					top: 10px;
					left: 6px;
					transform: skewX(165deg);
				}
			}
			.cpImage{
				height: 240px;
			}
			.cp_zuo{
				width: 11px;
				height: 73px;
				background: #ECECEC;
				border-radius: 2px;
				.cp_zuo_img{
					width: 100%;
					height: 30px;
					background-repeat: no-repeat;
					background-size: 250%;
					background-position: center;
					background-image: url('../../assets/image/cp_zuo_1.png');
				}
			}
			.cp_zuo:hover {
				background: #3546A0;
			}
			.cp_zuo:hover .cp_zuo_img{
				background-image: url('../../assets/image/cp_zuo_2.png');
			}
			.cp_you{
				width: 11px;
				height: 73px;
				background: #ECECEC;
				border-radius: 2px;
				.cp_yuo_img{
					width: 100%;
					height: 30px;
					background-repeat: no-repeat;
					background-size: 250%;
					background-position: center;
					background-image: url('../../assets/image/cp_yuo_2.png');
				}
			}
			.cp_you:hover {
				background: #3546A0;
			}
			.cp_you:hover .cp_yuo_img{
				background-image: url('../../assets/image/cp_yuo_1.png');
			}
			.cp_box{
				min-width: 100%;
				width: 0;
				overflow: hidden;
				.cp_item{
					margin-right: 1%;
					.cp_item_img{
						width: 113px;
						height: 75px;
						background-repeat: no-repeat;
						background-size: cover;
						background-position: center;
					}
				}
			}
			.noSelect{
				border: 1px solid transparent;
			}
			.select{
				border: 1px solid #3546A0;
			}
			.scq_item{
				width: 48%;
				margin-bottom: 12px;
			}
			.lianxiwomen{
				// height: 316px;
				.lianxiwomen_zuo{
					// width: 40%;
				}
				.lianxiwomen_map{
					height: 300px;
					margin-bottom: 20px;
				}
			}
			#map{
				.BMap_cpyCtrl, .anchorBL {
					display: none !important;
				}
			}
			.pp{
				display: flex;
				text-align: justify;
			}
			.lingxing{
				display: inline-block;
				margin-top: 16px;
				width: 10px;
				height: 10px;
				background-color: #3546A0;
				transform: skewX(157deg);
				margin-right: 10px;
			}
		}
	}
</style>